import * as Comp from "..";
import { is, List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as AdminEventActions from "../../actions/AdminEventActions";
import { Event } from "../../models/event";
import { AppState } from "../../store";
import { ItemLoadingState } from "../../models/generic";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    events: state.adminEvents.events,
    loading: state.adminEvents.loadingEvent,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    loadData: (eventId: number) => dispatch(AdminEventActions.loadEvent(eventId)),
    toggleLoading: (eventId: number, loading: boolean) => dispatch(AdminEventActions.toggleLoadingEvent(eventId, loading)),
});

interface OwnProps {
    eventId: number;
    onUpdated: (loading: boolean, events: Event) => void;
}

type ConnectedState = Comp.Base.DefaultConnectedState & {
    events: List<Event>;
    loading: ItemLoadingState;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    loadData: (eventId: number) => void;
    toggleLoading: (eventId: number, loading: boolean) => void;
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class LoaderComponent extends React.Component<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidMount() {
        this.loadDataFromStore(true);
    }

    public componentDidUpdate(prevProps: Readonly<CombinedProps>) {
        if (!is(prevProps.events, this.props.events))
            this.loadDataFromStore();
        if (!is(prevProps.loading, this.props.loading))
            this.loadDataFromStore();
    }

    public render() {
        return null;
    }

    private loadDataFromStore(isInitialCheck: boolean = false) {
        const evt = this.props.events.find((x) => x !== undefined && x.id === this.props.eventId);
        this.props.onUpdated(!!this.props.loading[this.props.eventId], evt);

        if (isInitialCheck) {
            this.props.loadData(this.props.eventId);
            if (!evt)
                this.props.toggleLoading(this.props.eventId, true);
        }
    }
}

export const AdminEventLoader: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(LoaderComponent);



// WEBPACK FOOTER //
// ./src/components/reusable/AdminEventLoader.tsx